export const mhw = {
  body_background_color: '#E1B042',

  logo_image_url: 'mhw.png',
  logo_height: '170',

  header_border_color: '#F0F1F1',
  header_padding: '0',

  button_color: '#BB5D30',
  button_radius: 12,

  button_half_border_color: '#BB5D30',

  text_font: `'Roboto', sans-serif`,
  title_font: `'Roboto', sans-serif`,

  footer_border_color: '#F0F1F1',

  number_hidden: true,

  token_width: 60,
  token_margin_left: 10,
  token_url: 'mhw/Tortue_noire.jpg',
}

export const mhw_orange = {
  ...mhw,
  token_url: 'mhw/Tortue_Orange.jpg',
}

export const mhw_jaune = {
  ...mhw,
  token_url: 'mhw/Tortue_Jaune.jpg',
}
